import { render, staticRenderFns } from "./TableHeadStatusBase.vue?vue&type=template&id=61ba9db6"
import script from "./TableHeadStatusBase.vue?vue&type=script&lang=ts"
export * from "./TableHeadStatusBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports